import { render, staticRenderFns } from "./BarcodeDialog.vue?vue&type=template&id=748480d0"
import script from "./BarcodeDialog.vue?vue&type=script&lang=js"
export * from "./BarcodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports